import { useGetData, useToggleStatusMutation } from "@/services";
import { MasterModuleLayout, useMasterModule } from "../Common";
import useOCPDocTypes from "./useOCPDocTypes";

const OCPDocTypes = () => {
  const { columns } = useOCPDocTypes();

  const masterHook = useMasterModule({
    queryKey: "ocp-document-types",
    idKey: "documentTypeId",
    nameKey: "documentName",
    useGetDataQuery: useGetData,
    useToggleStatusMutation: useToggleStatusMutation,
    // isStatusUpdateApi: true,
    // hideActiveSwitch: true,
    module: "ocp-document-types",
    isCommunityQuery: true,
    statusSuccessMessage: "OCP Document Type Status Updated Successfully",
  });

  return <MasterModuleLayout title="OCP Document Types" hookResult={masterHook} extraColumns={columns} />;
}

export default OCPDocTypes;